import { CenteredLoader } from 'new/elements/CenteredLoader';
import { FlowNodes } from 'js/components/pipelines/FlowNodes';
import { Stack } from 'new/elements/Stack';
import React from 'react';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { GET_PIPELINE_REQUEST, GET_PIPELINES_REQUEST } from 'js/constants/actionTypes';
import useEntities from 'new/state/entities/repository/useEntities';
import usePipelinesItems from 'js/components/pipelines/ExpandedPipelines/hooks/usePipelinesItems';
import { useSelector } from 'react-redux';
import { pipelineItemsSelector } from 'new/elements/ResourceSelectionButton/components/pipelinesItemSelector';
import { isEmpty } from 'lodash';

export default function DefaultExpandView({ item }) {
  const pipelineItems = useSelector((state: any) => pipelineItemsSelector(state, item));
  const loadingFlow = useIsLoading(GET_PIPELINE_REQUEST, GET_PIPELINES_REQUEST);
  const { data: flowNodes } = useEntities('flowNodes');
  const flow = flowNodes?.[item?.origin_node_id];

  const { triggeringMap } = usePipelinesItems(flow ? [flow] : []);

  return (
    <Stack borderTop="1px solid var(--color-outline)" height={500} position="relative">
      {loadingFlow && isEmpty(pipelineItems) ? (
        <CenteredLoader absolute />
      ) : (
        <FlowNodes
          id={`flow-${item.origin_node_id}`}
          pipelineItems={pipelineItems}
          triggeringMap={triggeringMap}
          miniMapPosition="bottom-left"
          nodeProps={{
            isPreview: true,
          }}
        />
      )}
    </Stack>
  );
}
